/* eslint-disable @typescript-eslint/no-explicit-any */
// import {HomeComponent} from '../HomeComponent';
import React, {useEffect} from 'react';
import {
  FlatList,
  Image,
  ImageStyle,
  TouchableOpacity,
  View,
} from 'react-native';
import {connect} from 'react-redux';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import {styles} from './styles';

export function ListPaiementComponent(props: any) {
  const {data, isHome} = props;
  const [item, setData] = React.useState(data);

  useEffect(() => {
    setData(data);
  }, [data]);

  return (
    <View
      style={
        isHome ? styles.containerMenuItemIsHome : styles.containerMenuItemProfil
      }>
      <FlatList
        style={{paddingBottom: 10}}
        data={item}
        scrollEnabled={true}
        numColumns={isHome ? 3 : 2}
        keyExtractor={(item, index) => `payment-${index}`}
        renderItem={({item}: {item: any}) => (
          <TouchableOpacity
            style={
              item.title === 'Airtel'
                ? styles.containerPaimentItemAirtel
                : item.title === 'Orange'
                ? styles.containerPaimentItemOrange
                : item.title === 'Visa'
                ? styles.containerPaimentItemVisa
                : item.title === 'Comptant'
                ? styles.containerPaimentItemComptant
                : [
                    styles.containerPaimentItem,
                    {minHeight: 134, justifyContent: 'center'},
                  ]
            }
            key={`${item.title}_${isHome ? 3 : 2}`}
            onPress={() => {
              item.handleMove();
            }}>
            <Image
              style={
                [
                  styles.MenuItemLogo,
                  !isHome ? styles.spaceItemLogo : {},
                ] as ImageStyle[]
              }
              source={item.source}
            />
          </TouchableOpacity>
        )}
      />
    </View>
  );
}

export const ListMenuPaiement: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ListPaiementComponent);
